export enum SessionType {
    Practice,
    GameDay,
    All
}
